import type { TripPhoto } from '../../types';
import { tripPhotoUrl } from '../../utils/tripPhotos';
import { SelectableTile } from './PhotoSelection';

/** `compact`: inside a diary entry. `thumb`: the all-days overview, a strip of small squares. */
export type PhotoGridSize = 'full' | 'compact' | 'thumb';

interface Props {
  photos: TripPhoto[];
  onOpen: (photo: TripPhoto) => void;
  size?: PhotoGridSize;
}

const LAYOUT: Record<PhotoGridSize, string> = {
  full: 'grid gap-2 grid-cols-2 sm:grid-cols-3 md:grid-cols-4',
  compact: 'grid gap-2 grid-cols-3 sm:grid-cols-4',
  thumb: 'flex flex-wrap gap-1.5',
};

export default function PhotoGrid({ photos, onOpen, size = 'full' }: Props) {
  if (photos.length === 0) return null;
  return (
    <div className={LAYOUT[size]}>
      {photos.map(photo => (
        <SelectableTile
          key={photo.id}
          photo={photo}
          onOpen={onOpen}
          style={size === 'thumb' ? undefined : { aspectRatio: size === 'compact' ? '1 / 1' : photo.width && photo.height ? `${photo.width} / ${photo.height}` : '1 / 1' }}
          className={`relative block overflow-hidden bg-slate-100 dark:bg-slate-800 cursor-pointer group ${size === 'thumb' ? 'w-20 h-20 rounded-lg' : 'w-full h-full rounded-xl'}`}
        >
          <img
            src={tripPhotoUrl(photo.thumbnailFilename ?? photo.filename)}
            alt={photo.originalName}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform"
          />
        </SelectableTile>
      ))}
    </div>
  );
}
